<template>
  <div>
    <information-facture-rapprochement
        :facture="facture">
    </information-facture-rapprochement>
    <filtre-rapprochement
        class="mgt-20px"
        :moduleType="moduleType"
        :query="query"
        :facture="facture"
        @refresh="$emit('refreshCommandeAchat')">
    </filtre-rapprochement>
    <montant-rapprochement
        class="mgt-20px"
        :facture="facture"
        :commandeAchatARapprocher="commandeAchatARapprocher">
    </montant-rapprochement>
    <commande-achat-a-rapprocher
        class="mgt-20px"
        :moduleType="moduleType"
        :facture="facture"
        :commandeAchatARapprocher="commandeAchatARapprocher">
    </commande-achat-a-rapprocher>
  </div>
</template>

<script>
import informationFactureRapprochement from '@/components/baux/factureAchatARapprocher/edition/rapprochement/informationFactureRapprochement';
import filtreRapprochement from '@/components/baux/factureAchatARapprocher/edition/rapprochement/filtreRapprochement';
import montantRapprochement from '@/components/baux/factureAchatARapprocher/edition/rapprochement/montantRapprochement';
import commandeAchatARapprocher from '@/components/baux/factureAchatARapprocher/edition/rapprochement/commandeAchatARapprocher';

export default {
  name: 'FactureAchatARapprocherEditRapprochement',
  props: {
    facture: {
      type: Object,
      required: true,
    },
    commandeAchatARapprocher: {
      type: Array,
      required: true,
    },
    query: {
      type: Object,
      required: true,
    },
    moduleType: {
      type: String,
      required: true,
    },
  },
  components: {
    informationFactureRapprochement,
    filtreRapprochement,
    montantRapprochement,
    commandeAchatARapprocher,
  },
};
</script>

<style scoped>

</style>
